import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import Millimetre from "../../../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function Verformungsamplitude({
  bemessungslast,
  knicklastDesGebettetenPfahls,
  verformungsamplitude,
}) {
  const { t } = useTranslation("translation");
  const w_0_Formula = `\\displaystyle w_{\\tiny  _{0}} = e _{\\tiny  _{0}} \\cdot \\frac{N_{\\tiny _{Fd}}}{N_{ki} - N_{\\tiny _{Fd}}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.lateralDeformationAmplitude")}</p>}
      indicesValue={
        <span>
          w<sub>0</sub>
        </span>
      }
      formulaValue={<ToolTip id={"w_0_Formula"} type={IconType.FORMULA} formula={w_0_Formula} />}
      inputValue={
        <span className="input">
          {bemessungslast > knicklastDesGebettetenPfahls
            ? "XXX"
            : ConvertToString(verformungsamplitude, 2, "XXX")}
        </span>
      }
      unitValue={<Millimetre />}
    />
  );
}

export default Verformungsamplitude;
